export const sentryPages = ["/painel", "/completar-cadastro", "/investir"];
